import request from '@/plugin/axios'

export function AccountLogin(data) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        data: data
    })
}
export function getLoginUser() {
    return request({
        url: '/api/auth/me',
        method: 'post'
    })
}

export function createImg() {
    return request({
        url: '/api/auth/captcha',
        method: 'post'
    })
}

export function checkCertCenterLogin() {
    return request({
        url: '/api/auth/checkCertCenterLogin',
        method: 'get'
    })
}

export function loginout(data) {
    return request({
        url: `${process.env.VUE_APP_LOGIN_SERVER_URL}/adminSso/loginout`,
        data,
        method: 'post'
    })
}
